var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":10}},[_c('el-col',{staticClass:"card-view-number-multiple-col",attrs:{"span":8}},[_c('div',{staticClass:"target-text"},[_c('b',[_vm._v("Цель")]),_vm._v(": "+_vm._s(_vm.scale.target))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }